/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useState } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { AiOutlineFileText } from 'react-icons/ai';
import VideoIcon from '../../../../assets/SvgIcons/resources/CategoryVideo.svg';
import NoteIcon from '../../../../assets/SvgIcons/resources/CategoryNote.svg';
import subCatIcon from '../../../../assets/SvgIcons/resources/subCategory.svg';
import RecordIcon from '../../../../assets/SvgIcons/resources/Categoryrecorder.svg';
import '../../Shimmer/HelpandSupportShimmer/Shimmer.css';
import useResourceHelper from '../../../../containers/BusinessSettings/Components/RevisedResources/ResourcesManagement/Components/Reusable/ContentCards/useResourceHelper';

interface CategoryDetailProps {
  selectedCategory: any;
  labelText: string;
}

const CategoryDetail: React.FC<CategoryDetailProps> = ({ selectedCategory, labelText }) =>
{
	// Handle image error for the detail view
	const [ selectedImgError, setSelectedImgError ] = useState(false);
	const [ isImageLoaded, setIsImageLoaded ] = useState(false);
	const { getRandomBackgroundImage } = useResourceHelper();
	const handleSelectedImageError = () =>
	{
		setSelectedImgError(true);
	};

	const handleImageLoad = () =>
	{
		setIsImageLoaded(true);
	};

	return (
		<Stack direction='column' spacing={2} sx={{ width: '100%', height: '100%', overflowY: 'auto', padding: '10px' }}>
			<Box
				component='img'
				key={selectedCategory.id || selectedCategory._id}
				src={selectedImgError ? getRandomBackgroundImage : (selectedCategory.image || selectedCategory.thumbnailUrl || getRandomBackgroundImage)}
				alt='Category'
				onLoad={handleImageLoad}
				onError={handleSelectedImageError}
				sx={{ width: '100%', height: '120px', borderRadius: '6px', objectFit: labelText === 'Companies' ? 'contain' : 'cover' }}
				{...(!isImageLoaded && { className: 'shimmer' })}
			/>
			<Typography variant='body1' fontWeight={500} color='#737373'>
				{selectedCategory.title || selectedCategory.name}
			</Typography>
			<Stack direction={'row'} alignItems={'center'} spacing={1} justifyContent={'space-between'}>
				<Stack direction={'row'} alignItems={'center'} spacing={1}>
					<Box component='img' src={subCatIcon} alt='Category' sx={{ width: '16px', height: '16px' }} />
					<Typography variant='body2' color='#737373'>{selectedCategory.subcategoryCount || 0}</Typography>
				</Stack>

				<Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ borderLeft: '1px solid #E4E4E4', pl: 1 }}>
					<Box component='img' src={NoteIcon} alt='Category' sx={{ width: '16px', height: '16px' }} />
					<Typography variant='body2' color='#737373'>{selectedCategory?.contentCount?.articles || 0}</Typography>
				</Stack>

				<Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ borderLeft: '1px solid #E4E4E4', pl: 1 }}>
					<Box component='img' src={VideoIcon} alt='Category' sx={{ width: '16px', height: '16px' }} />
					<Typography variant='body2' color='#737373'>{selectedCategory?.contentCount?.videos || 0}</Typography>
				</Stack>

				<Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ borderLeft: '1px solid #E4E4E4', pl: 1 }}>
					<Box component='img' src={RecordIcon} alt='Category' sx={{ width: '16px', height: '16px' }} />
					<Typography variant='body2' color='#737373'>{selectedCategory?.contentCount?.podcasts || 0}</Typography>
				</Stack>

				<Stack direction={'row'} alignItems={'center'} spacing={1} sx={{ borderLeft: '1px solid #E4E4E4', pl: 1 }}>
					<AiOutlineFileText style={{ color: '#737373' }} />
					<Typography variant='body2' color='#737373'>{selectedCategory?.contentCount?.documents || 0}</Typography>
				</Stack>
			</Stack>

			<Typography variant='body2' color='#737373'>
				{selectedCategory.description || ''}
			</Typography>
		</Stack>
	);
};

export default CategoryDetail;